module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_1.ec7cfdf2.png";